import React from 'react';
import { useMetaMask } from '../../../../hooks/useMetaMask';
import styles from './metamask-button.module.scss';

export const MetaMaskButton: React.FC = () => {
  const { account, connectWallet, disconnectWallet } = useMetaMask();

  const handleButtonClick = () => {
    if (account) {
      disconnectWallet();
    } else {
      connectWallet();
    }
  };

  return (
    <div>
      <button
        onClick={handleButtonClick}
        type="button"
        className={`${styles.metamaskButton} ${
          account ? styles.connected : ''
        }`}
      >
        <span className={styles.accountText}>
          {account ? `Disconnect ${account.substring(0, 6)}` : 'Connect Wallet'}
        </span>
      </button>
    </div>
  );
};
